<template>
  <base-data-table
    :items="riskAssessmentHistories"
    title="リスクアセスメント履歴"
    header-icon="mdi-clipboard-text-outline"
    :column-widths="['160px', '120px', '160px', '160px', '170px']"
  >
    <template #header-cells>
      <th>入力日時</th>
      <th>結果</th>
      <th>相談サービス</th>
      <th>相談員</th>
      <th />
    </template>
    <template #cells="{ row: riskAssessment }">
      <td>{{ riskAssessment.inputAt }}</td>
      <td>
        <div class="total-score-line">
          <span>{{ riskAssessment.score }}</span>
          <v-chip
            :class="riskAssessment.positive ? 'positive-result-chip' : 'negative-result-chip'"
            size="x-small"
            variant="flat"
          >
            {{ riskAssessment.result }}
          </v-chip>
        </div>
        <div v-text="`(非該当 ${riskAssessment.notApplicableCount} 不明 ${riskAssessment.unknownCount})`" />
      </td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ riskAssessment.consultationService }}
        </div>
      </td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ riskAssessment.counselorName }}<br>
          {{ riskAssessment.counselorDepartment }}
        </div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          prepend-icon="mdi-open-in-new"
          @click="$emit('open-karte', riskAssessment)"
        >
          相談カルテを開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetRiskAssessmentHistoryTable",
  components: {
    BaseDataTable
  },
  props: {
    riskAssessmentHistories: {
      type: Array,
      default: () => []
    }
  },
  emits: ["open-karte"]
};
</script>

<style lang="scss" scoped>
.negative-result-chip {
  margin-left: 4px;
  background-color: #f2f2f2;
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
}

.total-score-line {
  align-items: center;
  display: flex;
}

.positive-result-chip {
  margin-left: 4px;
  background-color: #fdeff2;
  color: #c8384f;
  font-weight: bold;
}
</style>
